import React, { useEffect } from 'react';
import { Formik } from 'formik';
import { useStore } from 'hooks';
import { VALIDATION } from 'helpers/constants';
import { Button } from 'components/ui/form';
import { Input } from 'components/ui/formik';
import { AuthService } from 'services';
import * as Yup from 'yup';
import logoSi from '../../../assets/images/logo_si.png';
import patternImg from '../../../assets/images/pattern-left-side.png';
import styles from './new-password.module.scss';

const newPasswordValidationSchema = Yup.object().shape({
  newPassword: Yup.string()
    .min(5, 'Пароль должен быть от 5 до 16 символов')
    .max(16, 'Пароль должен быть от 5 до 16 символов')
    .required(...VALIDATION.REQUIRED),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('newPassword')], 'Пароли не совпадают')
    .required(...VALIDATION.REQUIRED),
});

const NewPasswordPage = ({
  match: {
    params: { token },
  },
  history,
}) => {
  const { setUser, setLoading } = useStore();

  useEffect(() => {
    (async () => {
      setLoading(true);
      const response = await new AuthService({ setUser }).checkToken({ token });
      setLoading(false);
      if (response.status === 0) {
        history.push('/restore');
      }
    })();
  }, [history, token, setUser, setLoading]);

  const initialValues = {
    newPassword: '',
    confirmPassword: '',
  };

  const onSubmit = async (values) => {
    setLoading(true);
    const response = await new AuthService({ setUser }).recoveryPassword({ ...values, token });
    setLoading(false);
    if (response.status) {
      history.push('/login');
    }
  };

  const patternStyle = { backgroundImage: `url(${patternImg})` };

  return (
    <main className="page-login">
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={newPasswordValidationSchema}
        onSubmit={onSubmit}
      >
        {({ handleSubmit }) => (
          <form onSubmit={handleSubmit} className={styles.login} autoComplete="off">
            <div className={styles.head}>
              <div className={styles.title}>Введите ваш новый пароль</div>
              <img src={logoSi} alt="Гранит" className={styles.logo} />
            </div>
            <div className={styles.fields}>
              <div className={styles.field}>
                <Input name="newPassword" type="password" placeholder="Ваш новый пароль" />
              </div>
              <div className={styles.field}>
                <Input name="confirmPassword" type="password" placeholder="Подтвердите ваш новый пароль" />
              </div>
            </div>
            <div>
              <Button
                type="submit"
              >
                Изменить пароль
              </Button>
            </div>
          </form>
        )}
      </Formik>
      <div className={styles.patternBottomRight} style={patternStyle} />
    </main>
  );
};

export default NewPasswordPage;
